// Node imports
import { dispatcher, ingenuity } from "@quest/base-core";
import { BaseView } from "@quest/base-core/dist/ui/BaseView";
import { FreeGameState } from "@quest/murka-games-behavior-panther/dist/";
import { FgCascadingReelPanelView } from "../FreeGame/FgCascadingReelPanelView";
import { FgCascadingReelPanelController } from "../FreeGame/FgCascadingReelPanelController";
import { FgClusterWinFrameController } from "../FgClusterWinFrame/FgClusterWinFrameController";
import { FgClusterWinFrameView } from "../FgClusterWinFrame/FgClusterWinFrameView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { FreeGameProgressBar } from "../FreeGame/FreeGameProgressBar";
import { FreeGameView } from "../FreeGame/FreeGameView";
import { FGQLinePlayerMsgController } from "../FreeGame/FGQLinePlayerMsgController";
import { FgRevealSymbolController } from "../FreeGame/FgRevealSymbolController";

export class FreeGameStateGame extends FreeGameState {
  protected view: FreeGameView
  private fgCascadeView: BaseView;
  private fgClusterWinFrameView: FgClusterWinFrameView;
  protected fgClusterWinFrameController: FgClusterWinFrameController;

  // Overrided to Initialize some features and to fire events
  public init(): void {
    super.init();
    this.initializeFgCascadingReelPanelController();
    this.initializeBaseGameProgressBar();
    this.initializeFgPlayerMsg();
    this.initializeFgRevealSymbol();
  }
  // Overrided to subscribe events
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.INITIALIZE_FG_CLUSTER_WIN_FRAME, this.initializeFgClusterWinFrame, this);
  }

  // Overrided to un subscribe events
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.INITIALIZE_FG_CLUSTER_WIN_FRAME, this.initializeFgClusterWinFrame, this);
  }
  /**
   * To initialized cascade reel view and controller
   */
  private initializeFgCascadingReelPanelController(): void {
    this.fgCascadeView = new FgCascadingReelPanelView(
      ingenuity.currentGame.cache.getJSON("main_data").cascadingReelPanel
    );
    this.view.addChild(this.fgCascadeView);
    new FgCascadingReelPanelController(this.view, this.fgCascadeView, this.model);
  }
  private initializeBaseGameProgressBar(): void {
    new FreeGameProgressBar(this.view);
  }
  // To initialize fg cluster win frame
  private initializeFgClusterWinFrame(): void {
    if (!this.fgClusterWinFrameView) {
      this.fgClusterWinFrameView = new FgClusterWinFrameView(
        ingenuity.currentGame.cache.getJSON("main_data").ClusterWinFrame
      );
      this.fgClusterWinFrameController = new FgClusterWinFrameController(this.fgClusterWinFrameView);
      this.winReelpanel.addChildAt(this.fgClusterWinFrameView, this.winReelpanel.children.length);
    }
  }
  //to initialie player msg controller for fg
  protected initializeFgPlayerMsg(): void {
    new FGQLinePlayerMsgController(this.view);
  }
  // to initialize reveal controller for fg
  protected initializeFgRevealSymbol(): void{
    new FgRevealSymbolController(this.view);
  }
    // to add mask
  protected initializeWinReelPresentation() {
    super.initializeWinReelPresentation();
    dispatcher.fireEvent(eventDispatchers.CREATE_WIN_MASK_FG);
  }

}
